<template>
  <div class="dash">
    <div class="dash__tiles">
      <StatTile tone="accent" label="Za naplatu" :value="money(d.potrazivanje)"
        :meta="fmt(d.red_naplate_ukupno) + ' predmeta s otvorenim saldom'" />
      <StatTile label="Predmeti sa uplatama (nisu zatvoreni)" :value="fmt(d.spremno_ukupno)" meta="saldo poravnat, faza otvorena" />
    </div>

    <div class="dash__body">
      <CaseList
        class="dash__main"
        title="Red naplate"
        subtitle="isplaćeno klijentu, još nije naplaćeno od osiguranja"
        :rows="d.red_naplate"
        metric="saldo"
        metric-label="Saldo (KM)"
        :footer="fmt(d.red_naplate_ukupno) + ' predmeta · ukupno ' + money(d.potrazivanje) + ' KM'"
        empty-text="Nema otvorenih salda"
      />

      <aside class="dash__rail">
        <section class="card">
          <h2 class="card__title">Saldo po osiguranju</h2>
          <div class="card__hint">koga zvati prvo</div>
          <div class="rows">
            <div v-for="o in d.po_obavezi" :key="o.obaveza" class="row">
              <div>
                <div class="row__label">{{ o.obaveza || "—" }}</div>
                <div class="row__bar"><span class="row__fill" :style="{ width: share(o.saldo) + '%' }"></span></div>
              </div>
              <span class="row__value">{{ money(o.saldo) }}</span>
            </div>
          </div>
        </section>

        <section class="card">
          <h2 class="card__title">Predmeti sa uplatama (nisu zatvoreni)</h2>
          <div class="card__hint">saldo 0, faza još otvorena</div>
          <div v-if="!d.spremno_za_zatvaranje.length" class="card__hint">Nema takvih predmeta</div>
          <div v-else class="ready">
            <div
              v-for="r in d.spremno_za_zatvaranje"
              :key="r.id"
              class="ready__row"
              @click="$router.push('/predmet/view/' + r.id)"
            >
              <strong>{{ r.broj }}</strong>
              <span class="ready__name">{{ r.osteceni || "—" }}</span>
              <StatusTag :value="r.status" />
            </div>
          </div>
        </section>
      </aside>
    </div>
  </div>
</template>

<script>
import StatTile from "./StatTile";
import CaseList from "./CaseList";
import StatusTag from "@/components/StatusTag";

export default {
  name: "FinanceDash",
  components: { StatTile, CaseList, StatusTag },
  props: { data: { type: Object, required: true } },
  computed: {
    d() {
      return this.data;
    },
    maxSaldo() {
      return Math.max.apply(null, (this.d.po_obavezi || []).map((o) => o.saldo).concat([1]));
    },
  },
  methods: {
    fmt(v) {
      return String(Math.round(Number(v) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    money(v) {
      const parts = Number(v || 0).toFixed(2).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(",");
    },
    share(v) {
      return Math.max((v / this.maxSaldo) * 100, 2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dash.scss";

.row__label {
  font-size: var(--fs-sm);
  color: var(--ink);
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ready {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
}

.ready__row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  background: var(--surface-alt);
  border-radius: var(--r-md);
  font-size: var(--fs-sm);
  cursor: pointer;

  &:hover {
    background: var(--brand-tint);
  }
}

.ready__name {
  flex-grow: 1;
  color: var(--ink-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
